import React from "react";
import styled from "@emotion/styled";
import { Theme, useMediaQuery } from "@mui/material";
import { ExtendedAccount } from "@features/depots/types";
import { InfoChips } from "@components/InfoChips/InfoChips";
import { useGetAccountChips } from "./useGetAccountChips";

const ExtenderColumn = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

interface Props {
  account: ExtendedAccount;
  direction?: "row" | "column";
}

export const AccountDetailsChips = ({ account, direction }: Props) => {
  const isMd = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));
  const chips = useGetAccountChips(account);

  if (!chips.length) {
    return null;
  }

  return (
    <ExtenderColumn
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <InfoChips
        options={chips}
        size="xsmall"
        direction={direction ?? (isMd ? "row" : "column")}
        noWrapLabels
      />
    </ExtenderColumn>
  );
};
